export class SharedRouteNames {
  public static readonly iFrameRoutes = {
    driftstatus: "iFrame/driftstatus",
    driftstatusMap: "iFrame/driftstatus-map",
    subscription: "iFrame/subscription",
    stdReceivers: "iFrame/std-receivers",
    confirmTwitter: "confirm-twitter"
  };

  public static readonly unavailable = "unavailable";
}
